import request from '../../axios';

export interface IGetAccountNumbersResponse {
  bank_account_number: string;
  bank_title: string;
  guid: string;
  iban_number: string;
}

export const getAccountNumbers = async () => {
  const {data}: {data: IGetAccountNumbersResponse[]} = await request.get(
    `/api/profile/bank-account-info`,
  );

  return data[0];
};
